import React from 'react';
import { useDropzone } from 'react-dropzone';
import upload from "assets/upload.svg";
import { SBBox, SBTypography } from "modules/Commons";
import { SBTranslate } from "i18n";
import { useStyles } from "../style";

import { FormControl, RadioGroup, FormControlLabel, Radio } from '@mui/material';

import { ImportMode } from '../index';

interface DistributionUploaderHelperSelectorProps {
    onFileAccepted: (file: File) => void;
    importMode: ImportMode;
    setImportMode: (mode: ImportMode) => void;
}

const DistributionUploaderHelperSelector: React.FC<DistributionUploaderHelperSelectorProps> = ({ onFileAccepted, importMode, setImportMode }) => {
    const { getRootProps, getInputProps } = useDropzone({
        onDrop: acceptedFiles => {
            onFileAccepted(acceptedFiles[0]);
        },
        noKeyboard: true,
    });
    const classes = useStyles();

    return (
        <SBBox className={classes.selectorUploader}>
            <SBBox className={classes.selectorUploader2}>
                <div {...getRootProps()}>
                    <input {...getInputProps()} />
                    <img src={upload} alt="Upload" height="150px" />
                    <SBTypography textAlign="center">
                        {SBTranslate("dragACSVFileHereOnly")}
                    </SBTypography>
                </div>
            </SBBox>
            <SBTypography mt={4} mb={2} textAlign="center">
                {SBTranslate("warningUploadModifiersCSV_part1")}<br />
                {SBTranslate("warningUploadModifiersCSV_part2")}
            </SBTypography>

            <SBBox display="flex" justifyContent="center" mb={1} mt={2}>
                <FormControl component="fieldset">
                    <RadioGroup
                        value={importMode}
                        onChange={(e) => setImportMode(e.target.value as ImportMode)}
                    >
                        <FormControlLabel 
                            value={ImportMode.Incremental} 
                            control={<Radio color="primary" />} 
                            label={
                                <SBBox mt={1}>
                                    <SBTypography fontWeight="600">{SBTranslate("importModeIncremental")}</SBTypography>
                                    <SBTypography variant="body2" color="gray3.main" className={classes.radioDescription}>
                                        {SBTranslate("importModeIncrementalDescription")}
                                    </SBTypography>
                                </SBBox>
                            } 
                            className={classes.radioLabelMargin}
                        />
                        <FormControlLabel 
                            value={ImportMode.Substitute} 
                            control={<Radio color="primary" />} 
                            label={
                                <SBBox mt={1}>
                                    <SBTypography fontWeight="600">{SBTranslate("importModeSubstitute")}</SBTypography>
                                    <SBTypography variant="body2" color="gray3.main" className={classes.radioDescription}>
                                        {SBTranslate("importModeSubstituteDescription")}
                                    </SBTypography>
                                </SBBox>
                            } 
                            className={classes.radioLabel}
                        />
                    </RadioGroup>
                </FormControl>
            </SBBox>
        </SBBox>
    );
};

export default DistributionUploaderHelperSelector;
